<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useConfigStore } from '../../stores/config'

withDefaults(defineProps<{
  menuType?: string
}>(), {
  menuType: ''
})

const { rsConfig } = storeToRefs(useConfigStore())

const getSocialLinks = () => rsConfig.value.socialSettings?.socialLinks ?? {}
</script>

<template>
  <div :class="['bx-' + menuType + '__social-links']">
    <span v-if="menuType === 'footer'"
          :class="['bx-' + menuType + '__social-links-headline']" />

    <a v-for="(socialNetworkUrl, socialNetwork) in getSocialLinks()"
       :key="socialNetwork"
       :href="socialNetworkUrl"
       rel="noopener"
       target="_blank"
       :aria-label="socialNetwork">
      <span :class="['icon', 'icon-' + socialNetwork, 'icon--' + menuType + '-social']">
        <svg><use :href="`#${socialNetwork}`" /></svg>
      </span>
    </a>
  </div>
</template>
